import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '../services/api';

const ClienteAuthContext = createContext(null);

export function ClienteAuthProvider({ children }) {
  const [cliente, setCliente] = useState(null);
  const [tokenCliente, setTokenCliente] = useState(null);
  const [loadingCliente, setLoadingCliente] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('cliente_token');
    const dados = localStorage.getItem('cliente_dados');
    if (token && dados) {
      try {
        setTokenCliente(token);
        setCliente(JSON.parse(dados));
      } catch {
        localStorage.removeItem('cliente_token');
        localStorage.removeItem('cliente_dados');
      }
    }
    setLoadingCliente(false);
  }, []);

  const loginCliente = useCallback(async (email, senha, empresa_id) => {
    const { data } = await api.post('/auth/login-cliente', { email, senha, empresa_id });
    localStorage.setItem('cliente_token', data.token);
    localStorage.setItem('cliente_dados', JSON.stringify(data.cliente));
    setTokenCliente(data.token);
    setCliente(data.cliente);
    return data;
  }, []);

  const registrarCliente = useCallback(async (dados) => {
    const { data } = await api.post('/auth/registrar-cliente', dados);
    return data;
  }, []);

  const logoutCliente = useCallback(() => {
    localStorage.removeItem('cliente_token');
    localStorage.removeItem('cliente_dados');
    setTokenCliente(null);
    setCliente(null);
  }, []);

  // Helper para chamadas autenticadas
  const authHeader = useCallback(() => {
    const token = localStorage.getItem('cliente_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }, []);

  const getPerfil = useCallback(() =>
    api.get('/cliente/perfil', { headers: authHeader() }), [authHeader]);

  const putPerfil = useCallback((dados) =>
    api.put('/cliente/perfil', dados, { headers: authHeader() }), [authHeader]);

  const getEnderecos = useCallback(() =>
    api.get('/cliente/enderecos', { headers: authHeader() }), [authHeader]);

  const postEndereco = useCallback((dados) =>
    api.post('/cliente/enderecos', dados, { headers: authHeader() }), [authHeader]);

  const putEndereco = useCallback((id, dados) =>
    api.put(`/cliente/enderecos/${id}`, dados, { headers: authHeader() }), [authHeader]);

  const deleteEndereco = useCallback((id) =>
    api.delete(`/cliente/enderecos/${id}`, { headers: authHeader() }), [authHeader]);

  const patchPadrao = useCallback((id) =>
    api.patch(`/cliente/enderecos/${id}/padrao`, {}, { headers: authHeader() }), [authHeader]);

  const getPedidos = useCallback((params) =>
    api.get('/cliente/pedidos', { headers: authHeader(), params }), [authHeader]);

  const getPedido = useCallback((id) =>
    api.get(`/cliente/pedidos/${id}`, { headers: authHeader() }), [authHeader]);

  return (
    <ClienteAuthContext.Provider value={{
      cliente,
      tokenCliente,
      loadingCliente,
      loginCliente,
      registrarCliente,
      logoutCliente,
      getPerfil,
      putPerfil,
      getEnderecos,
      postEndereco,
      putEndereco,
      deleteEndereco,
      patchPadrao,
      getPedidos,
      getPedido,
    }}>
      {children}
    </ClienteAuthContext.Provider>
  );
}

export function useClienteAuth() {
  const ctx = useContext(ClienteAuthContext);
  if (!ctx) throw new Error('useClienteAuth deve ser usado dentro de ClienteAuthProvider');
  return ctx;
}
